import { Box, CircularProgress, Typography } from "@mui/material";
import I18n from "i18next";

import MzButton from "@markaaz/ui/MzButton";
import MzAlert from "@markaaz/ui/MzAlert";
import TimeRange from "./TimeRange";
import BarChart from "../../../commonComponents/BarChart/BarChart";
import StackedBarChart from "commonComponents/stackedBarChart/stackedBarChart";
import StackedGroupChart from "commonComponents/stackedGroupChart/stackedGroupChart";
import IllustrativeImage from "commonComponents/illustrativeImage/illustrativeImage";

const sx = {
  customCard: {
    background: (theme) => theme.palette.common.white,
    borderRadius: "10px",
    padding: "50px",
    marginBottom: "40px"
  },
  customAlert: {
    display: "flex",
    justifyContent: "center",
    width: "100%"
  }
};

const OverViewWidget = ({
  title,
  color,
  alertText,
  legendText,
  downloadURL,
  data,
  type,
  spinner,
  count,
  stackedBar,
  stackedGroup,
  barChart,
  bar1Color,
  bar2Color,
  legendText1,
  legendText2,
  disableTimeRange,
  disableButton,
  illustrativeImage,
  showLegendText,
  epPortfoliosId,
  tileName,
  menuSelect
}) => {
  const downLoadFile = () => {
    const link = document.createElement("a");
    link.href = downloadURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Box sx={sx.customCard}>
      <Box display="flex" flexWrap="wrap" gap="10px" justifyContent="space-between" alignItems="baseline">
        <Box>
          <Typography variant="h5" color="darkBlue.c100">
            {title}
          </Typography>
          <Typography variant="body2" color="#66668F">
            {alertText}
          </Typography>
        </Box>
        {disableTimeRange ? (
          <TimeRange disabled={true} />
        ) : (
          <TimeRange type={type} epPortfoliosId={epPortfoliosId} tileName={tileName} menuSelect={menuSelect} />
        )}
      </Box>
      <IllustrativeImage display={illustrativeImage} title="Illustrative" />
      {spinner ? (
        <Box width="100%" display="flex" justifyContent="center" alignItems="center" height="500px">
          <CircularProgress />
        </Box>
      ) : data ? (
        data.length ? (
          <>
            <Box className="py-2">
              {stackedBar && <StackedBarChart count={count} legendText={legendText} data={data} color={color} />}
              {stackedGroup && (
                <StackedGroupChart
                  legendText1={legendText1}
                  legendText2={legendText2}
                  data={data}
                  bar1Color={bar1Color}
                  bar2Color={bar2Color}
                />
              )}
              {barChart && (
                <BarChart
                  count={count}
                  legendText={legendText}
                  data={data}
                  color={color}
                  showLegendText={showLegendText}
                />
              )}
            </Box>
            <Box flexWrap="wrap" gap="10px" display="flex" alignItems="center" justifyContent="end">
              {disableButton ? (
                <MzButton variant="contained" color="primary" size="large">
                  {I18n.t("common.exportData")}
                </MzButton>
              ) : (
                <MzButton variant="contained" color="primary" size="large" onClick={downLoadFile}>
                  {I18n.t("common.exportData")}
                </MzButton>
              )}
            </Box>
          </>
        ) : (
          <Box sx={sx.customAlert}>{I18n.t("common.noDataFound")}</Box>
        )
      ) : (
        <Box sx={sx.customAlert}>
          <MzAlert severity="error">{I18n.t("errors.somethingWrong")}</MzAlert>
        </Box>
      )}
    </Box>
  );
};

export default OverViewWidget;
